<template>
    <div class="anjian">
        <div class='card-right-top'>
            <!--Card v-if="menuName == 'new_client' ||
			            menuName == 'first_recycle_client'|| 
						menuName == 'two_recycle_client'||
						menuName == 'three_recycle_client'||
						menuName == 'three_add_recycle_client'">
                <PublicPond :menuName="menuName"></PublicPond>
            </Card-->
            <Card v-if="menuName == 'media_set' ">
                <PublicPond></PublicPond>
            </Card>			

            <Card v-if="menuName == 'client_sea' ">
                <MareLiberumMenu></MareLiberumMenu>
            </Card>
        </div>
    </div>
</template>

<script>
    import PublicPond from './PublicPond.vue'
    import MareLiberumMenu from './MareLiberumMenu.vue'
    import {mapGetters} from "vuex";

    export default {
        name: "MareLiberum",
        components: {PublicPond, MareLiberumMenu},
        computed: {
            ...mapGetters(['userInfo'])
        },
        created() {
            // 初始化菜单图标
            this.initIcon();
        },
        data() {
            return {
                menuName: 'media_set',
                openNames: ['media_set'],
                iconList: [],
                subMenuList: [
                    {
                        name: '公共池', key: 'media_set', children: [
                            {name: '新客户', key: 'new_client'},
                            {name: '首次回收客户', key: 'first_recycle_client'},
                            {name: '2次回收客户', key: 'two_recycle_client'},
                            {name: '3次回收客户', key: 'three_recycle_client'},
                            {name: '3次以上回收客户', key: 'three_add_recycle_client'}
                        ]
                    }
                ]
            }
        },
        methods: {
            initIcon() {
                let that = this
                this.userInfo.menuList.mareLiberum.children.forEach(function (row, index) {
                    that.iconList[index] = require('../../assets/icons/mareLiberum/'+row.key+'.png');
                })
            },
            menuItem(e) {
                this.menuName = e;
            },
        }

    }
</script>

<style scoped lang="less">

    .menuIcon{
        display: inline-block;
        width: 15px;
        height: 15px;
        vertical-align: middle;
        margin-bottom: 3px;
        margin-right: 5px;
    }
    /deep/ .badge{
        position: absolute;
        width: 50px;
        height: auto;
        top: 30%;
        right: 14%;
    }
</style>